<template>
  <div class="pages7PcWarp w100">
    <div class="pages7PcWarpItem" v-for="(v,i) in viewPointList" @click="goDetail(v)" v-if="i <= 3">
      <div class="title fOH">{{ v.title }}</div>
      <div class="time fOH">{{ v.time }}</div>
    </div>
  </div>
</template>
<script>
export default {
  computed:{
    viewPointList(){
      return this.$store.getters.homeData.viewPointList
    }
  },
  methods:{
    async goDetail(v){
      if(v.id){
        await this.$store.dispatch('setStoreByKeyData', {key: 'setViewPointInfo', data: v})
        this.$router.push({name:"ViewpointDetail",query:{id:v.id}})
      }
    }
  }
}
</script>
<style scoped lang="scss">
.pages7PcWarp {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  overflow: hidden;
  .pages7PcWarpItem:nth-child(odd) {
    margin-right: 4rem;
  }

  .pages7PcWarpItem:nth-child(even) {
    margin-left: 4rem;
  }

  .pages7PcWarpItem {
    border-bottom: .05rem solid rgba(255, 255, 255, .7);
    width: calc(50% - 4rem);
    padding-bottom: 1rem;
    margin-top: 4vh;
    cursor: pointer;
    position: relative;

    .title {
      color: #fff;
      font-size: 1rem;
      line-height: 1.7rem;
      padding-bottom: 7vh;
      @media (max-height: 800px) and (min-height: 700px) {
        font-size: .85rem;
        line-height: 1.2rem;
      }
      @media (max-height: 699px) {
        font-size: .75rem;
        line-height: 1rem;
      }
    }

    .time {
      position: absolute;
      bottom: 1rem;
      left: 0;
      z-index: 10;
      color: #8FCADD;
      font-size: .75rem;
      @media (max-height: 800px) and (min-height: 700px) {
        font-size: .55rem;
        //line-height: 1.2rem;
      }
      @media (max-height: 699px) {
        font-size: .45rem;
        //line-height: 1.2rem;
      }
    }
  }
}
</style>
